module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__zip-code-container"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].zip),
      expression: "$parent.form[$parent.address].zip",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$parent.$v.form[_vm.$parent.address].zip.$error
    },
    attrs: {
      "type": "zipcode",
      "name": "postal-code",
      "minlength": "4",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].zip)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "zip", $event.target.value.trim())
      }, function($event) {
        _vm.$parent.$v.form[_vm.$parent.address].zip.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "postal-code"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            PLZ\n        ")]), _c('span', {
    staticClass: "required-symbol"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("(Pflichtfeld)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753a57d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/PostalCode.vue
// module id = 823
// module chunks = 0